module.exports = __webpack_public_path__ + "img/wenhao.2465fea4.png";